var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 184,
    viewBox: "0 0 158 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8574 131.468C24.7923 104.188 42.6269 95.4514 58.22 91.2471C62.6423 70.1802 76.7973 70.9132 83.322 73.9131C94.1299 66.4497 103.013 75.3266 106.103 80.6979C112.525 72.796 119.786 81.2501 122.614 86.4649C126.406 85.2378 132.593 81.4298 136.289 100.221C148.313 142.495 104.494 164.307 90.0552 164.134C75.6161 163.961 52.9225 158.749 38.8574 131.468Z",
    fill: "#FD9BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.056 130.333C117.454 133.649 124.767 141.993 126.835 148.839",
    stroke: "#2A7158",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.973 122.269C122.099 126.796 129.945 132.956 136.316 121.37C142.687 109.785 136.026 94.8402 131.516 87.8751",
    stroke: "#23236F",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.982 74.8434C52.7239 80.0731 58.0003 90.5299 65.1706 90.5189",
    stroke: "#2A7158",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3083 51.041C22.1435 77.992 42.2168 77.8958 50.8991 74.4788C72.9737 62.2106 75.1784 47.597 72.226 30.396C69.8641 16.6352 56.57 18.9261 50.2182 21.7917C41.0667 9.22846 27.9793 19.3634 22.5796 26.0013C19.5256 24.7383 2.34382 28.8675 11.3083 51.041Z",
    fill: "#F96F4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7044 31.996L39.8084 13.4774",
    stroke: "#D04D25",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3594 35.0395C47.9221 30.6841 49.5144 21.7302 51.3819 20.7578",
    stroke: "#D04D25",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.752 36.0024C30.4632 30.7731 26.3652 19.7452 28.2836 17.4682",
    stroke: "#D04D25",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4718 41.6766C15.0941 38.6759 21.8071 35.5479 27.6813 47.0419C31.4244 38.7711 41.2658 26.1569 50.6861 41.8668C52.5235 36.1021 57.9188 25.6854 64.8008 30.1365",
    stroke: "#D04D25",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.302 129.564C103.083 134.152 110.768 138.931 119.265 121.35C127.762 103.769 125.3 91.4899 122.802 86.8626",
    stroke: "#23236F",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1285 132.791C79.0002 138.541 83.9142 146.69 96.5964 133.285C109.279 119.879 108.237 92.4775 106.13 80.4525",
    stroke: "#23236F",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8921 74.4995C93.5818 86.088 87.3224 113.35 82.3874 123.805C81.2185 127.881 77.0565 135.699 69.7604 134.364C62.4644 133.028 63.4034 124.862 64.7848 120.946C68.5176 111.116 74.5564 89.7449 68.849 82.8998",
    stroke: "#23236F",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7506 125.303C73.0977 116.591 58.9174 116.678 53.5338 117.81L57.8903 94.4509C71.1025 88.0239 88.7982 100.527 95.9945 107.583C109.366 117.442 95.8416 131.555 86.7506 125.303Z",
    fill: "#FD9BA9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3209 117.267C59.7045 116.135 73.8848 116.048 87.5377 124.76C96.6287 131.012 110.153 116.899 96.7816 107.04C89.5853 99.9845 71.8896 87.4809 58.6774 93.9079",
    stroke: "#23236F",
    strokeWidth: 1.86906,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6499,
    cy: 11.8119,
    r: 1.86906,
    transform: "rotate(-34.6268 26.6499 11.8119)",
    fill: "#D45029"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4653,
    cy: 9.05749,
    r: 1.86906,
    transform: "rotate(-34.6268 40.4653 9.05749)",
    fill: "#D45029"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8198,
    cy: 14.2347,
    r: 1.86906,
    transform: "rotate(-34.6268 53.8198 14.2347)",
    fill: "#D45029"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8369 79.785C49.8446 82.4946 44.0907 87.34 37.0137 85.0448C37.9248 81.8211 42.1651 76.2559 51.8369 79.785Z",
    fill: "#2A7158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.6cf089255d9237468db355c3236b7fca.svg";
export { ForwardRef as ReactComponent };